module.exports = __webpack_public_path__ + "static/q4answer3_rainforest_wishmas-1d78156de7ac3272e978c0a18811bcc2.jpg";